import { render, createElement } from '@wordpress/element';
import LogoLoop from './LogoLoop';
import './LogoLoop.css';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wp-block-opaline-logo-loop').forEach((root) => {
    const imgs = root.querySelectorAll('.logoloop__node');
    const logos = Array.from(imgs).map((img) => ({
      src: img.getAttribute('src'),
      alt: img.getAttribute('alt') || '',
      title: img.getAttribute('title') || '',
    }));

    const props = {
      logos,
      speed:        parseInt(root.dataset.speed || '120', 10),
      direction:    root.dataset.direction || 'left',
      logoHeight:   parseInt(root.dataset.logoheight || '48', 10),
      gap:          parseInt(root.dataset.gap || '40', 10),
      fadeOut:      root.dataset.fadeout === 'true',
      fadeOutColor: root.dataset.fadeoutcolor || '#ffffff',
    };

    root.innerHTML = '';
    render(createElement(LogoLoop, props), root);
  });
});
